<template>

  <div class="container">
    <section class="content-wrap">
      <ul class="user-tab">
        <li>{{$t('お気に入りの記事')}}</li>
      </ul>

      <div class="sort-box">
        <div class="set-hit"><span>{{clipList.length}}</span>{{$t('件')}}</div>
        <!-- <dl>
          <dt>{{$t('絞り込み')}}</dt>
          <dd id="app">
            <button type="button" class="btn" @click="showModal" > {{$t('カテゴリー')}} </button>
            <modal v-show="isModalVisible"  @search="search" @close="closeModal">
              <span slot="result">{{clipList.length}}</span>
            </modal>
          </dd>
          <dd id="app">
            <button type="button" class="btn" @click="showModalArea" > {{$t('エリア')}} </button>
            <modalArea v-show="isModalVisibleArea"  @searchByArea="searchByArea" @close="closeModalArea">
              <span slot="result">{{clipList.length}}</span>
            </modalArea>
          </dd>
          <dl></dl>
        </dl> -->
      </div>

      <div class="loader" v-if="this.dataloading">
        <div class="loader-inner ball-scale-multiple">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div v-else class="set-itemList">
        <ul class="c-horizontalList" v-if="clipList.length">
          <li class="c-post" :data-article-id="article.article_id" v-for="(article, index) in clipList" :key="index">
            <div class="thumb c-ratioBox" style="padding-bottom: 62.5%" >
              <a class="btnFav active" id="btnFav" href="javascript:;" @click="removeBookmark(article.article_id, $event)"></a>
              <a :href="constants.MATCHA_MEDIA_SSL_URL+ $store.state.languageName + '/'+article.article_id" class="c-imageLink">
                <img class=" lazyloaded" :data-src="article.image.large" :alt="article.title"
                  :src="article.image.large"> </a>
            </div>
            <div class="content">
              <h3 class="title">
                <a :href="constants.MATCHA_MEDIA_SSL_URL+$store.state.languageName + '/'+article.article_id">{{article.title}}</a>
              </h3>
              <a v-if="article.region.child" :href="constants.MATCHA_MEDIA_SSL_URL+ $store.state.languageName + '/list/?region='+ article.region.child.id + '&category=all'">
                <p class="meta meta-place">{{article.region.child.name}}</p>
              </a>
            </div>
          </li>
        </ul>
        <ul v-else class="no-clip">
          <img src="https://resources.matcha-jp.com/static_resources/user/no-clip-matchan.png" class="lazyloaded">
          <h3 class="empty-artcile">{{$t('お気に入りの記事はありません')}}</h3>
          <p>{{$t('気に入った記事をどんどんお気に入り登録していきましょう！')}}</p>
          <a :href="constants.MATCHA_SITE + languageName">{{$t('[記事を探す]')}}</a>
        </ul>
      </div>
      </section>
  </div>

</template>


<script>
import * as constants from '@/constants'
// import modal from '@/components/modal/category'
// import modalArea from '@/components/modal/area'
import { mapMutations, mapState, mapGetters, mapActions } from 'vuex'
import clipsapi from '@/api/clip'
import articles from '@/api/articles'


export default {

  mounted(){
    clipsapi.getClipList({ accessToken: this.accessToken })
    .then((result) => {
      let kijilist = result.data.data
      let articlesList = ''

      kijilist.forEach(element => {
        articlesList+= element +','
      })
      articlesList = articlesList.slice(0, -1)
      
      if(kijilist.length > 0 ) {
        articles.getArticles({lang_id: this.lang_id, article_ids: articlesList})
        .then((res) =>{
          this.$store.dispatch('getArticlesDetails', res.data.data)
          this.clipList =  res.data.data
          this.dataloading = false
        })
        .catch((err) => {
          this.dataloading = false;
        })
      }else{
        this.dataloading = false
      }
    })

    // Get All Clip Category
    this.$store.dispatch('getAllClipCategory', this.accessToken)
    // For Send Data to Google Tag manager 
    this.$gtm.trackView('BookmarkedArticleLists', 'currentpath')
  },
  data(){
    return {
      clipList: [],
      constants: constants,
      dataloading: true,
      languageName: this.$store.state.languageName,
      isModalVisible: false,
      isModalVisibleArea: false,
      error:[],
      totalData:2,
      categoryFilterId: null
    }

  },
  computed:{
    ...mapState(['clips', 'user']),
    ...mapGetters({
      email: 'email',
      accessToken: 'accessToken',
      lang_id: 'languageId',
      dataList: 'articleList',
      clip_category_id: 'userClipCategory',
    }),
    ...mapActions({
      removeArticleFromStore : 'removeArticleFromStore'
    })

  },
  // components:{
  //   modal,
  //   modalArea
  // },
  methods: {
    removeBookmark(id, event) {

      this.$gtm.trackEvent({
        event: 'GAEvent', // Event type [default = 'interaction'] (Optional)
        category: this.email + 'User_My_Page',
        action: 'Remove Bookmark',
        label: this.lang_id+'/'+id,
        value: 1,
        noninteraction: false // Optional
      })

      var e = event.target;
      var parentList = e.parentElement.parentElement
      parentList.classList.add("list-leave-loading")

      this.$swal({
        title: this.$t('Are you sure?'),
        text: this.$t("This article will remove from your bookmark lists."),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
      }).then((result) => {
          this.deleteArticleFromApi(id, event)
      }).catch((err) => {
          parentList.classList.remove("list-removed")
          parentList.classList.remove("list-leave-loading")       
      })

    },

    deleteArticleFromApi(id, event){
      var e = event.target;
      var parentList = e.parentElement.parentElement

      //Starting dele,ting procedure
      let params = {
        article_id: id,
        login_token: this.accessToken,
        clip_category_id: this.clip_category_id
      }          
      clipsapi.removeFromFavorite(params)
      .then((result) => {
        if (result.status === 200) {
          parentList.classList.add("list-removed")
          var timeout
          let self = this
          setTimeout  (()=> {
            self.$store.dispatch('removeArticleFromStore', id)
            parentList.classList.remove("list-removed")
            parentList.classList.remove("list-leave-loading")
          }, 600)
        } else{ 
          this.$swal({
            type: 'error',
            title: this.$t('Oops...'),
            text: this.$t('Article un-clip failure!'),
          })
          parentList.classList.remove("list-removed")
          parentList.classList.remove("list-leave-loading")
        }
      })
      .catch((error) => {
        this.$swal({
          type: 'error',
          title: this.$t('Oops...'),
          text: this.$t('Article un-clip failure!'),
        })
        parentList.classList.remove("list-removed")
        parentList.classList.remove("list-leave-loading")
      })
    },

    showModal() {
      this.isModalVisible = true;
    },

    closeModal() {
      this.isModalVisible = false;
    },

    search(id){
      let self = this
      let retVal = []

      if(id == 'all') {
        return this.clipList = this.dataList
      }

      this.dataList.forEach((post) => {
        let categoryList = []

        if(post.category.length !== 0){
          if(typeof post.category.parent != 'undefined'){
            categoryList.push(post.category.parent.id)
          }
          if(typeof post.category.child != 'undefined'){
            categoryList.push(post.category.child.id)
          }
        }
        
        categoryList.filter((cat) => {
          if(id.indexOf(cat) > -1){
            retVal.push(post)
          }
        }).length === id.length
      })

      return this.clipList = this.multiDimensionalUnique(retVal)
    },
    
    showModalArea() {
      this.isModalVisibleArea = true;
    },

    closeModalArea() {
      this.isModalVisibleArea = false;
    },

    searchByArea(id){
      let self = this
      let retVal = []

      if(id == 'all') {
        return this.clipList = this.dataList
      }
      
      this.dataList.forEach((post) => {
        let areaList = []
        if(post.region.length !== 0){
          if(typeof post.region.parent != 'undefined'){
            areaList.push(post.region.parent.id)
          }
          if(typeof post.region.child != 'undefined'){
            areaList.push(post.region.child.id)
          }
        }

        areaList.filter((reg) => {
          if(id.indexOf(reg) > -1){
            retVal.push(post)
          }
        }).length === id.length
      })
      return this.clipList = this.multiDimensionalUnique(retVal)
    },

    multiDimensionalUnique(arr) {
      var uniques = [];
      var itemsFound = {};

      for(var i = 0, l = arr.length; i < l; i++) {
        var stringified = JSON.stringify(arr[i]);
        if(itemsFound[stringified]) { continue; }
        uniques.push(arr[i]);
        itemsFound[stringified] = true;
      }
      return uniques;
    }
  },

  // For Meta & Header Tag 
  metaInfo() {
    return {
      title: this.$t('お気に入りの記事') + ' | '+ this.$t('MATCHA - JAPAN TRAVEL WEB MAGAZINE'),
      htmlAttrs: {
        lang: this.languageName
      },
      description: this.$t('footer.guide_text_short')
    }
  },  


}
</script>
<style>

.list-leave-loading /* .list-leave-active below version 2.1.8 */ {
  opacity: .5;
}
.list-removed{
  transition: all 0.4s ease-out;
  opacity: 0;
  height: 2em;
}
</style>



// WEBPACK FOOTER //
// src/pages/clip/index.vue